export default {
  'component_tracking_day_label': 'Tracking Day',
  'component_tracking_day_key_days': 'Key Days',
  'component_tracking_day_customize': 'Customize',
  'component_tracking_day_error': 'You entered improper number.<br /> Please re-enter the tracking day in [1,{maximumDays}].',
  'component_tracking_day_placeholder': 'Please Enter Tracking Day, For Example: 7.',
  'component_tracking_day_confirm': 'Confirm',
  'component_tracking_day_back': 'Back',
}